// extracted by mini-css-extract-plugin
module.exports = {"texts":"texts--3ORxl","texts__content":"texts__content--3Hzt1","texts__description":"texts__description--3l8yL"};